<template>
  <main class="main shop_profile" role="main" v-if="isShowShop">
    <div class="main_con">
      <div class="s_p_i_wrap">
        <ShopProfileInfo
          :shop="shop"
          :isShowShop="isShowShop"
          :isConsentView="isConsentView"
          :priorConsentCheck="priorConsentCheck"
          :existPriorConsentLabels="existPriorConsentLabels"
          :isCustomer="isCustomer"
        ></ShopProfileInfo>
      </div>

      <div class="shop_detail_tab">
        <ul>
          <li class="pnt" :class="{ on: isInfoTab }">매장 소개</li>
          <li class="pnt" :class="{ on: !isInfoTab }" @click="moreReview">
            리뷰({{ shop.reviewCnt }}건)
          </li>
        </ul>
      </div>
      <div class="shop_info_common" v-if="shop.info">
        <div class="s_i_wrap">
          <div class="s_i_top">
            <div class="top_title">매장 소개</div>
          </div>
          <ShopIntroduceInfo :shopInfo="shop.info"></ShopIntroduceInfo>
        </div>
      </div>
      <div class="shop_info_common" v-if="shop.storePhotos">
        <div class="s_i_wrap">
          <div class="s_i_top">
            <div class="top_title">매장 사진</div>
          </div>
          <ShopPhotosInfo :shopPhotos="shop.storePhotos"></ShopPhotosInfo>
        </div>
      </div>
      <div class="shop_info_common" v-if="shop.reviews.length > 0">
        <div class="s_i_wrap">
          <div class="s_i_top">
            <div class="top_title">최근 상담 리뷰</div>
          </div>
          <Reviews :reviews="shop.reviews" />
          <div
            class="sec_review_plus pnt"
            @click="moreReview"
            v-if="isReviewTotal"
          >
            <div class="review_plus_txt">더 많은 리뷰보기</div>
            <div class="review_plus_img">
              <img src="@/assets/front/images/new/ar_small_pri.svg" alt="" />
            </div>
          </div>
        </div>
        <button
          class="review_float_btn"
          v-if="isReviewWrite"
          @click="reviewWrite"
          :style="{ bottom: isBtnView ? '6.6rem' : '2.2rem' }"
        >
          <i class="i_write"></i><i class="i_red_dot"></i>리뷰작성
        </button>
      </div>
    </div>
    <div class="btm_btn" v-if="isBtnView">
      <div class="btn_wrap">
        <div class="left">
          <!-- <label class="b_btn btn_like"
            ><input
              type="checkbox"
              :checked="shop.followed"
              @click.stop.prevent="toggleFollow(shop, shop.id)"
              v-model="shop.followed"
            />
            <span class="i_heart"></span>
          </label> -->
          <button class="b_btn i_call" @click="openTel()"></button>
          <!-- <button class="b_btn i_location" @click="openStoreMap"></button> -->
          <label class="b_btn btn_like"
            ><input
              type="checkbox"
              :checked="shop.followed"
              @click.stop.prevent="toggleFollow(shop, shop.id)"
              v-model="shop.followed"
            />
            <span class="i_heart"></span>
          </label>
        </div>
        <button class="btn" @click="enterChatRoom" v-if="isChatBtn">
          채팅 상담 문의
        </button>
        <button class="btn" :disabled="!isChatBtn" v-else>
          지금은 영업시간이 아닙니다.
        </button>
      </div>
    </div>
  </main>
</template>

<script>
import ShopProfileInfo from '@/common/components/shop/ShopProfileInfo.vue';

import ShopIntroduceInfo from '@/common/components/shop/ShopIntroduceInfo.vue';

import ShopPhotosInfo from '@/common/components/shop/ShopPhotosInfo.vue';

import Reviews from '@/front/customer/views/shops/components/Reviews.vue';

import { mapActions as commonMapActions } from '@common/store/modules/common';
import * as commonActions from '@common/store/modules/common/types';

import {
  mapActions as estimateMapActions,
  mapGetters as estimateMapGetters,
} from '@common/store/modules/estimate';
import * as estimationTypes from '@common/store/modules/estimate/types';

import {
  mapActions as shopMapActions,
  mapGetters as shopMapGetters,
} from '@common/store/modules/shop';
import * as shopTypes from '@common/store/modules/shop/types';

import {
  mapActions as reviewMapActions,
  mapGetters as reviewMapGetters,
} from '@common/store/modules/review';
import * as reviewTypes from '@common/store/modules/review/types';

import {
  mapActions as userMapActions,
  mapGetters as userMapGetters,
} from '@common/store/modules/user';
import * as userTypes from '@common/store/modules/user/types';

import {
  mapActions as chatMapActions,
  mapState as chatMapState,
  mapGetters as chatMapGetters,
} from '@common/store/modules/chat';
import * as chatActions from '@common/store/modules/chat/types';
import * as chatGetters from '@common/store/modules/chat/getters';

import { authMapGetters, authGetters } from '@common/store/modules';

import {
  checkMobileOperatingSystem,
  setCallbackOnClickBackKey,
  nativeEnableBackKey,
  nativeDisableBackKey,
  sdk_logEvent,
  sdk_logEventKakao,
} from '@common/lib/common/utils';

export default {
  components: {
    ShopProfileInfo,
    ShopIntroduceInfo,
    ShopPhotosInfo,
    Reviews,
  },
  data() {
    return {
      isChatBtn: false,
      isShowShop: false,
      isConsentView: false,
      priorConsentCheck: false,
      priorConsentKoLabel: {
        certOffMobile: '오프라인 무선',
        certOnMobile: '온라인 무선',
        certOffInternet: '오프라인 유선',
        certOnInternet: '온라인 유선',
        certAgency: '대리점 인증마크',
      },
      existPriorConsentLabels: [],
      isInfoTab: true,
      isReviewTotal: true,
      isShowWithdrawalModal: false,
      // bottomBtn 값이 있으면 false, 없으면 true
      isBtnView: !this.$route.query.bottomBtn || false,
      isReviewWrite: false,
    };
  },
  async created() {
    await this.fetch(this.$route.params.id);
    await this.getShopPriorConsent();
    await this.fetch_review();
    console.log(this.shop);
  },
  async beforeRouteEnter(to, from, next) {
    return next(async vm => {
      // await vm.fetch(to.query.id);
      // await vm.fetch_review();
      // await vm.getShopPriorConsent();
      // setCallbackOnClickBackKey(vm.handleOnClickBackKey);
    });
  },
  mounted() {
    this.isBtnView = !this.$route.query.bottomBtn;
  },
  computed: {
    ...userMapGetters({
      user: userTypes.USER,
      owner: userTypes.OWNER,
    }),
    ...shopMapGetters({
      shop: shopTypes.SHOP,
      shopPriorConsent: shopTypes.SHOP_PRIOR_CONSENT,
    }),
    ...chatMapGetters({
      chatroom_with: chatGetters.CHATROOMS_WITH,
      chatroom: chatGetters.CHATROOM,
    }),
    ...authMapGetters({
      currentUser: authGetters.CURRENT_USER,
    }),
    ...estimateMapGetters({
      autoEstimation: estimationTypes.AUTO_ESTIMATION,
    }),
    isCustomer() {
      return process.env.VUE_APP_APP_NAME === 'customer';
    },
  },

  methods: {
    ...commonMapActions([
      commonActions.SET_DIALOG,
      commonActions.HIDE_DIALOG,
      commonActions.SET_SNACKBAR,
    ]),
    ...shopMapActions([
      shopTypes.FETCH_SHOP,
      shopTypes.SHOP_FOLLOW,
      shopTypes.SHOP_UNFOLLOW,
      shopTypes.FETCH_SHOP_PRIOR_CONSENT,
    ]),
    ...reviewMapActions([
      reviewTypes.FETCH_REVIEWS,
      reviewTypes.FETCH_REVIEW_CHECK,
    ]),
    ...userMapActions([
      userTypes.OWNER_UPDATE_ME,
      userTypes.OWNER_SYNC_ME,
      userTypes.FETCH_OWNER,
      userTypes.FETCH_ME,
      userTypes.USER_DELETE_ME,
      userTypes.SET_OWNER_PROFILE,
    ]),
    ...chatMapActions([
      chatActions.FETCH_CHATROOM_WITH_STORE,
      chatActions.CHATROOMS_WITH_RESET_STATE,
      chatActions.UPDATE_MEMBER_SCREEN_ACTIVED_ALL,
      chatActions.CREATE_CHATROOM,
    ]),
    ...estimateMapActions([estimationTypes.FETCH_AUTO_ESTIMATION_IN_PROGRESS]),
    async fetch(id) {
      const params = { id: id };
      await this[shopTypes.FETCH_SHOP](params).then(() => {
        this.isShowShop = true;
      });

      let now = new Date();
      var week = new Array('7', '1', '2', '3', '4', '5', '6'); // 일, 월, 화, 수, 목, 금, 토

      let hours = now.getHours(); // 시
      let minutes = now.getMinutes(); // 분

      var startTime = this.shop.counselStart.split(':');
      var endTime = this.shop.counselEnd.split(':');

      console.log(hours);
      console.log(startTime[0]);
      console.log(endTime[0]);
      console.log('this.shop');
      console.log(this.shop);

      // 있음, 영업함
      if (this.shop.counselDay.indexOf(week[now.getDay()]) !== -1) {
        // 시간 확인
        if (parseInt(startTime[0]) <= hours && parseInt(endTime[0]) >= hours) {
          if (parseInt(endTime[1]) < minutes && parseInt(endTime[0]) == hours) {
            this.isChatBtn = false;
          } else {
            this.isChatBtn = true;
          }
        } else {
          this.isChatBtn = false;
        }
      } else {
        this.isChatBtn = false;
      }
    },
    async getShopPriorConsent() {
      try {
        const param = {
          id: this.shop.id,
        };

        await this[shopTypes.FETCH_SHOP_PRIOR_CONSENT](param);

        if (
          this.shopPriorConsent.certAgency ||
          this.shopPriorConsent.certOffInternet ||
          this.shopPriorConsent.certOffMobile ||
          this.shopPriorConsent.certOnInternet ||
          this.shopPriorConsent.certOnMobile
        ) {
          this.priorConsentCheck = true;

          // 등록된 사전승낙서 종류
          delete this.shopPriorConsent.storeId;
          for (const cons in this.shopPriorConsent) {
            if (this.shopPriorConsent[cons] !== '') {
              this.existPriorConsentLabels.push(this.priorConsentKoLabel[cons]);
            }
          }
        }
        this.isConsentView = true;
      } catch (err) {
        console.log(err);
        this.isConsentView = false;
        // return;
      }
      console.log(this.shopPriorConsent);

      this.isView = true;
    },
    moreReview() {
      this.isInfoTab = false;
      this.$router.push({
        name: 'Shops.Reviews',
        params: { id: this.shop.id },
        query: { type: 'normal' },
      });
    },
    goMypageProfile(sel_id) {
      this.$router.push({
        name: 'MyPage.Profile',
        query: { selId: sel_id },
      });
    },
    async fetch_review() {
      const params = {
        storeId: this.shop.id,
        visible: true,
        del: false,
      };

      let reviewData = await this[reviewTypes.FETCH_REVIEWS](params);

      console.log(reviewData);

      // 리뷰 작성 여부 확인
      const params2 = {
        storeId: this.shop.id,
        reviewType: 'NORMAL',
      };

      const checkReview = await this[reviewTypes.FETCH_REVIEW_CHECK](params2);

      if (checkReview.reviewed === 0 && checkReview.chat > 0) {
        this.isReviewWrite = true;
      }

      // 리뷰 더보기 버튼 노출 유무
      if (reviewData.content.length > 0) {
        this.isReviewTotal = true;
      } else {
        this.isReviewTotal = false;
      }
    },
    openTel() {
      console.log(this.shop);
      console.log(this.currentUser);
      const params = {
        shop_id: this.shop.id,
        shop_name: this.shop.name,
        user_id: this.currentUser.id,
        user_nickname: this.currentUser.nickname,
      };

      console.log(params);
      sdk_logEvent('SHOP_TEL', params);
      sdk_logEventKakao('SHOP_TEL');
      document.location.href = `tel:${this.shop.telNumber}`;
    },
    async enterChatRoom() {
      this[chatActions.CHATROOMS_WITH_RESET_STATE]();
      await this[chatActions.FETCH_CHATROOM_WITH_STORE]({
        chatRoomType: 'OneOnOne',
        storeId: this.shop.id,
      });
      console.log('this.chatroom_with');
      console.log(this.chatroom_with);

      let name = 'chat.room';
      const params = {};
      if (this.chatroom_with.count == 0) {
        // name = 'chat.room.create';
        // params.storeId = this.shop.id;
        // console.log('chat.room.create.1');

        this[chatActions.CREATE_CHATROOM]({
          chatRoomType: 'OneOnOne',
          memberId: '',
          storeId: this.shop.id,
          estimateId: undefined,
        }).then(() => {
          console.log('this.chatroom');
          console.log(this.chatroom);
          params.uuid = this.chatroom.uuid;
          params.createRoom = 'N'; // 일반 상담 제외

          this.$router.push({
            name,
            params,
          });
        });
      } else {
        params.uuid = this.chatroom_with.content[0].uuid;
        console.log('chat.room.create.3');

        this.$router.push({
          name,
          params,
        });
      }

      // this.$router.push({
      //   name,
      //   params,
      // });
    },
    async toggleFollow(shop, id) {
      const self = this;
      const funAutoEstimationInProgress = async () => {
        await self[estimationTypes.FETCH_AUTO_ESTIMATION_IN_PROGRESS]({
          userId: self.currentUser.id,
          storeId: id,
        });
      };
      const funToggle = async function() {
        //console.log(shop);
        await self[
          shop.followed ? shopTypes.SHOP_UNFOLLOW : shopTypes.SHOP_FOLLOW
        ]({ id: id });
        await self[shopTypes.FETCH_SHOP]({ id: id });
      };
      if (shop.followed) {
        await funAutoEstimationInProgress();
        if (self.autoEstimation.id) {
          self[commonActions.SET_DIALOG]({
            type: 'confirm',
            icon: 'warning',
            //title: this.$t('common.confirm'),
            message:
              '관심매장 해지시 자동견적서 발송이 취소 됩니다. 해지 하시겠습니까?',
            okCb: async () => {
              await funToggle();
              //this.$router.go(-1);
            },
          });
        } else {
          await funToggle();
        }
      } else {
        await funToggle();
      }
    },
    reviewWrite() {
      this.$router.push({
        name: 'Shops.WriteReview',
        params: { id: this.shop.id },
        query: { type: 'normal' },
      });
    },
  },
};
</script>
